const Eiffel = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={48}
    height={48}
    viewBox='0 0 48 48'
  >
    <g fill='none' fillRule='evenodd'>
      <circle cx={24} cy={24} r={20} fill='#f9e8eb' />
      <path
        fill='#FFF'
        fillRule='nonzero'
        d='M22.919 28.517l.656-2.997h1.296l.639 2.997h2.263c-1.278-3.216-2.263-6.448-2.436-12.625.605-.017.605-.085.605-.842v-.842c0-.757 0-.841-.64-.841h-.656V10.42c0-.421 0-.421-.432-.421s-.432 0-.432.42v2.947h-.639c-.656 0-.656.067-.656.841v.842c0 .757 0 .825.622.842-.173 6.177-1.158 9.41-2.454 12.625h2.264zm8.258 6.194c-1.21-1.818-2.074-3.434-2.955-5.353H20.19c-.864 1.92-1.728 3.535-2.937 5.353-.363.539-.363.539.19.539h3.023c.484 0 .484 0 .519-.505.207-2.138 1.727-2.862 3.23-2.862s3.024.724 3.23 2.862c.035.505.035.505.52.505h3.022c.553 0 .553 0 .19-.539z'
      />
    </g>
  </svg>
);

export default Eiffel;
